import React from 'react';
import {ColorWhite} from 'src/styles/Colors';
import AppText from "../commons/AppText";
import {logDebug} from "../../utils/AppLog";
import {cloneDeep} from "lodash";
import JackpotGameView, {SLOT_GAME_END_DELAY_MS} from "./JackpotGameView";
import {FontWeightMedium} from "src/res/FontWeight";
import ImageBackground from "../commons/ImageBackground";
import View from "../commons/View";
import GameAudio from "../commons/GameAudio";
import {GAME_NEUTRAL_AUDIO} from "../../utils/GameAudioPlayer";
import {locString} from "../commons/ViewHelper";

const GAME_END_DELAY_MS = 1.2 * 1000;

export default class GameBettingPicView extends React.Component {

    constructor(props) {
        super(props);
        this.selectionItems = props.items;
        this.refSlots = {};
        this.columns = 1;

        this.selectedIndexes = [];
        for (let i = 0; i < this.columns; i++) {
            this.selectedIndexes.push(0);
        }
        this.state = {
            ideal: true,
            reloadSelectedIndex: false
        };
    }

    componentWillUnmount() {
      for (let i = 0; i < this.props.rows; i++) {
        this.refSlots['refSlotView'+ i] = null;
        delete this.refSlots['refSlotView'+ i];
      }
    }

    simulatePlay = () => {
        const ref = this.refSlots['refSlotView'+ (this.props.rows - 1)];
        if (ref) {
            ref.simulatePlay();
        }
    }

    stop(stopData) {
        const endValues = stopData.endValues;
        for (let i = 0; i < this.props.rows; i++) {
            const cloneStopData = cloneDeep(stopData);
            cloneStopData.endValues = endValues[i];
            const ref = this.refSlots['refSlotView'+ i];
            ref.stop(cloneStopData);
        }
    }

    reset() {
        for (let i = 0; i < this.columns; i++) {
            this.selectedIndexes[i] = 0;
        }
        this.setState({ideal: true});

        for (let i = 0; i < this.props.rows; i++) {
            const ref = this.refSlots['refSlotView'+ i];
            if (ref) {
                ref.reset();
            }
        }
    }

    resetItems(items) {
        this.selectionItems = items;
        for (let i = 0; i < this.props.rows; i++) {
            const ref = this.refSlots['refSlotView'+ i];
            if (ref) {
                ref.resetItems(items);
            }
        }
    }

    render() {
        const cardSize = this.getCardSize();
        const isLTR = this.props.isLTR;
        const hideSpin = this.props.hideSpin;
        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;
        const sizeVFactor = uiConfigs.sizeVFactor;
        const collectedValue = this.props.collectedValue || '0';

        const spacingStartEnd = 14;
        const spacingBottom = 24;
        const bgBottomMargin = !hideSpin ? uiConfigs.spinViewHeight * sizeFactor + uiConfigs.spinButtonMarginTop * sizeVFactor : 0;
        const slotsViewWidth = cardSize * this.props.columns + uiConfigs.slotSpacing * (this.props.columns -1);
        return (
          <View style={{alignItems: 'center', width: '100%'}}>
              {!this.props.disableAudio ?
                <div>
                    <GameAudio ref={(ref) => this.gamePlayAudioIdNeutral = ref} source={GAME_NEUTRAL_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                </div>
                : null
              }
              {/*<View style={{position: 'relative', width: 300 * sizeFactor, height: 56 * sizeFactor, flexDirection: 'row', alignSelf: 'center', alignItems: 'center'}}>*/}
              {/*    <ImageBackground source={uiConfigs.collectionImage} resizeMode="fill" style={{position: 'absolute', left: 0, top: 0, bottom: 0, right: 0, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>*/}
              {/*        <View style={{position: 'relative', flex: 1, width: 160 * sizeFactor, flexDirection: 'row', alignSelf: 'center', marginLeft: isLTR ? 68 * sizeFactor : 78 * sizeFactor, marginRight: isLTR ? 78 * sizeFactor : 68 * sizeFactor, marginTop: 6 * sizeFactor}}>*/}
              {/*            /!*{isLTR ? this.getSelectedIndexesView() : null}*!/*/}
              {/*            <View style={{alignItems: 'center', justifyContent: 'center', marginLeft: isLTR ? 16 * sizeFactor : 8 * sizeFactor, marginRight: isLTR ? 8 * sizeFactor : 16 * sizeFactor, marginTop: 1 * sizeFactor}}>*/}
              {/*                <AppText fontSizeN={uiConfigs.fontSize} style={{fontWeight: FontWeightMedium, color: ColorWhite, backgroundColor: ColorUIChecker3}}>{collectedValue}</AppText>*/}
              {/*            </View>*/}
              {/*            /!*{!isLTR ? this.getSelectedIndexesView() : null}*!/*/}
              {/*        </View>*/}
              {/*    </ImageBackground>*/}
              {/*</View>*/}
              <View style={{minWidth: 100 * sizeFactor, minHeight: 30 * sizeFactor, borderStyle: 'solid', borderWidth: 4, borderBottomWidth: 2, borderColor: 'rgb(220,139,93)', backgroundColor: 'rgb(93,47,46)', borderTopLeftRadius: 12, borderTopRightRadius: 12, padding: 2 * sizeFactor}}>
                  <AppText fontSizeN={uiConfigs.fontSize} style={{align: 'center', fontWeight: FontWeightMedium, color: ColorWhite}}>{collectedValue}</AppText>
              </View>
              <View style={{position: 'relative', width: slotsViewWidth + 2 * spacingStartEnd * sizeFactor, justifyContent: 'center', alignItems: 'center'}}>
                  <View style={{position: 'absolute', left: 0, top: 0, bottom: bgBottomMargin, right: 0}} >
                    <ImageBackground source={uiConfigs.gameOuterBgImage} resizeMode="fill" style={{width: '100%', height: '100%'}} />
                  </View>
                  <View style={{width: slotsViewWidth, position: 'relative', justifyContent: 'center', alignItems: 'center', marginLeft: spacingStartEnd * sizeFactor, marginRight: spacingStartEnd * sizeFactor, marginBottom: spacingBottom * sizeFactor}}>
                      <View style={{justifyContent: 'center', width: slotsViewWidth, height: 36 * sizeFactor, marginBottom: 4 * sizeFactor}}>
                          <GetColumnsTitleView
                            uiConfigs={this.props.uiConfigs}
                            columns={this.props.columns}
                          />
                      </View>
                      <SlotsView
                        onRef={this.onRef}
                        disableAudio={this.props.disableAudio}
                        hideSpin={hideSpin}
                        cardSize={cardSize}
                        preview={this.props.preview}
                        rows={this.props.rows}
                        columns={this.props.columns}
                        noActionMode={this.props.noActionMode}
                        onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
                        mute={this.props.mute}
                        classes={this.props.classes}
                        contentWidth={this.props.contentWidth}
                        contentHeight={this.props.contentHeight}
                        uiConfigs={this.props.uiConfigs}
                        isLTR={this.props.isLTR}
                        items={this.props.items}
                        spinsLeft={this.props.spinsLeft}
                        spinsCount={this.props.spinsCount}
                        canSpin={this.props.canSpin}
                        onImageClicked={this.props.onImageClicked}
                        onSpinStarted={(row) => {
                            if (row === this.props.rows - 1) {
                                for (let i = 0; i < this.props.rows - 1; i++) {
                                    const ref = this.refSlots['refSlotView' + i];
                                    ref.start();
                                }
                                this.setState({ideal: false});
                                let selectedSlots = [];
                                this.selectedIndexes.forEach((index) => {
                                    selectedSlots.push(this.selectionItems[index].id);
                                });
                                this.props.onSpinStarted(selectedSlots);
                            }
                        }}
                        onSpinStopped={(row) => {
                            if (row === this.props.rows - 1) {
                                this.spinStopped();
                            }
                        }}
                      />
                  </View>
              </View>
          </View>
        );
    }

    onRef = (ref, row) => {
        this.refSlots['refSlotView' + row] = ref;
    };

    spinStopped() {
        const playNeutralAudio = () => {
            if (this.gamePlayAudioIdNeutral) {
                this.gamePlayAudioIdNeutral.play();
            }
        };

        playNeutralAudio();
        if (this.isSpinComplete) {
            playNeutralAudio();
        }
        // Vibration.vibrate(200);

        let delay = SLOT_GAME_END_DELAY_MS;
        if (this.isSpinComplete) {
            delay = GAME_END_DELAY_MS;
        }
        setTimeout(() => {
            this.setState({ideal: true});
            if (this.props.onSpinStopped) {
                this.props.onSpinStopped();
            }
        }, delay);
    }

    // getSelectedIndexesView() {
    //     const views = [];
    //     for (let i = 0; i < this.columns; i++) {
    //         const index = this.selectedIndexes[i];
    //         const item = this.selectionItems[index];
    //         const size = 52 * Utils.getSizeFactor();
    //         const eBoxSize = size - 4;
    //         views.push(
    //           <View style={{width: eBoxSize, height: eBoxSize, margin: 2, alignItems: 'center', opacity: this.state.ideal ? 1 : 0.8}}>
    //               <Touchable disabled={!this.state.ideal} key={'S'+ item.id} style={{width: eBoxSize, height: eBoxSize}} onPress={() => {
    //                   if (this.selectionItems.length > 1) {
    //                       let newIndex = index + 1;
    //                       if (newIndex === this.selectionItems.length) {
    //                           newIndex = 0;
    //                       }
    //                       this.selectedIndexes[i] = newIndex;
    //                       this.setState({reloadSelectedIndex: !this.state.reloadSelectedIndex})
    //                   } else {
    //                       this.props.onImageClicked(item.imageUrl);
    //                   }
    //               }}>
    //                   <View style={{width: eBoxSize - 2, height: eBoxSize - 2, alignItems: 'center', justifyContent: 'center', borderRadius: RadiusView}}>
    //                       {item.imageUrl ?
    //                         <AppImage
    //                           style={{
    //                               width: eBoxSize - 2,
    //                               height: eBoxSize - 2,
    //                               borderRadius: RadiusView
    //                           }}
    //                           imageUrl={item.imageUrl}
    //                           resizeMode={'contain'}
    //                         />
    //                         : item.icon ? <AppIcon icon={item.icon} color={item.color ? item.color : ColorTheme} size={36} /> : null}
    //                   </View>
    //               </Touchable>
    //           </View>
    //         );
    //     }
    //     return views;
    // }

    getCardSize() {
        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;

        const rows = this.props.rows;
        const columns = this.props.columns;
        const borderWidth = 28 * sizeFactor + (columns - 1) * uiConfigs.slotSpacing;
        const borderHeight = 80 * sizeFactor + (rows - 1) * 8;
        const otherUiHeight = 110 * sizeFactor;

        const possibleWidth = (this.props.contentWidth - borderWidth) / columns; // borderWidth
        const possibleHeight = (this.props.contentHeight - otherUiHeight - borderHeight) / rows; // borderWidth
        const possibleSize = Math.min(possibleWidth, possibleHeight);
        const cardSize = Math.floor(Math.min(200, possibleSize));
        return cardSize;
    }
}

const GetColumnsTitleView = React.memo((props) => {
    const {uiConfigs, columns} = props;
    const views = [];
    const multipliers = [1, 2, 5, 10, 20, 50, 100];
    for (let i = 0; i < columns; i++) {
        views.push(
          <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{display: 'flex', fontWeight: FontWeightMedium, color: 'rgb(247,195,62)', textAlign: 'center', flex: 1, justifyContent: 'center', marginLeft: i > 0 ? uiConfigs.slotSpacing : 0}}>
              {locString('multiplierWithValue', {value: multipliers[i]})}
          </AppText>
        );
    }
    return (
      <View style={{flexDirection: 'row'}}>
          {views}
      </View>
    );
});

const SlotsView = React.memo((props) => {
    const {disableAudio, hideSpin, rows, preview, noActionMode, onActionClickedInNoActionMode, mute, classes, contentWidth, contentHeight,
        uiConfigs, isLTR, cardSize, items, columns,
        spinsLeft, spinsCount, canSpin,
        onRef, onImageClicked, onSpinStarted, onSpinStopped} = props;
    const sizeFactor = uiConfigs.sizeFactor;
    const slotViews = [];
    for (let i = 0; i < rows; i++) {
        let hideSlotSpin = i < rows - 1;
        if (!hideSlotSpin) {
            hideSlotSpin = hideSpin;
        }
        slotViews.push(
          <View style={{marginTop: i > 0 ? 3 * sizeFactor : 0}}>
              <JackpotGameView
                disableAudio={disableAudio || i < rows - 1}
                ref={(ref) => onRef(ref, i)}
                preview={i === 0 ? preview : false}
                noActionMode={noActionMode}
                onActionClickedInNoActionMode={onActionClickedInNoActionMode}
                mute={mute}
                classes={classes}
                contentWidth={contentWidth}
                contentHeight={contentHeight}
                uiConfigs={uiConfigs}
                isLTR={isLTR}
                cardSize={cardSize}
                items={items}
                columns={columns}
                rows={1}
                hideSpin={hideSlotSpin}
                spinsLeft={spinsLeft}
                spinsCount={spinsCount}
                canSpin={canSpin}
                onImageClicked={onImageClicked}
                onSpinStarted={() => onSpinStarted(i)}
                onSpinStopped={() => onSpinStopped(i)}
              />
          </View>
        );
    }
    return slotViews;
});

